import { CssBaseline } from '@mui/material'
import { StyledEngineProvider, ThemeProvider } from '@mui/system'
import ProtectedRoute from 'components/authentication/ProtectedRoute'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import routes from 'routes'
import { appTitleKOR } from 'store/baseConfig'
import theme from 'themes'


const App = () => {
  const customization = useSelector((state) => state.customization);

  const router = createBrowserRouter(
    routes.map(route => {
      // protected 또는 mobileLoginRequired가 있는 경우 ProtectedRoute로 감싸기
      if (route.protected || route.mobileLoginRequired) {
        return {
          ...route,
          element: (
            <ProtectedRoute 
              allowedRoles={route.allowedRoles}
              mobileLoginRequired={route.mobileLoginRequired}
              mobileLoginRules={route.mobileLoginRules}
            >
              {route.element}
            </ProtectedRoute>
          ),
          children: route.children ? route.children.map(child => {
            // child의 protected 속성이 없을 경우 상위 route의 속성을 참조
            const isProtected = child.protected !== undefined ? child.protected : route.protected;
            const allowedRoles = child.allowedRoles || route.allowedRoles;
            const mobileLoginRequired = child.mobileLoginRequired !== undefined ? child.mobileLoginRequired : route.mobileLoginRequired;
            const mobileLoginRules = child.mobileLoginRules || route.mobileLoginRules;
  
            return {
              ...child,
              element: (isProtected || mobileLoginRequired || mobileLoginRules) ? (
                <ProtectedRoute 
                  allowedRoles={allowedRoles}
                  mobileLoginRequired={mobileLoginRequired}
                  mobileLoginRules={mobileLoginRules}
                >
                  {child.element}
                </ProtectedRoute>
              ) : (
                child.element
              ),
            };
          }) : undefined,
        };
      }
      return route;
    })
  );

  return (
    <StyledEngineProvider injectFirst>
      <Helmet>
        <title>{appTitleKOR}</title>
      </Helmet>
      <ThemeProvider theme={theme(customization)}>
        <CssBaseline />
        <RouterProvider router={router} />
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default App
